import { Injectable } from '@angular/core';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';

@Injectable({
    providedIn: 'root'
})
export class PdfServiceService {

    constructor() {
        GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.9.179/pdf.worker.min.js`;
    }


    async extractFirstPageAsImage(pdfUrl: string): Promise<string> {
        try {
            // Fetch PDF from S3 as a Blob
            const response = await fetch(pdfUrl);
            if (!response.ok) throw new Error('Failed to fetch PDF');

            const pdfBlob = await response.blob();
            const pdfArrayBuffer = await pdfBlob.arrayBuffer(); // Convert to ArrayBuffer

            // Load PDF
            const pdf = await getDocument({ data: pdfArrayBuffer }).promise;
            const page = await pdf.getPage(1);

            // Render first page to canvas
            const scale = 2; // Adjust scale for better resolution
            const viewport = page.getViewport({ scale });

            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d')!;
            canvas.width = viewport.width;
            canvas.height = viewport.height;

            const renderContext = { canvasContext: context, viewport };
            await page.render(renderContext).promise;

            return canvas.toDataURL('image/png'); // Convert to Base64 PNG
        } catch (error) {
            console.error('Error processing PDF:', error);
            return '';
        }
    }
}
